"use client";

export const LAMPORTS_PER_SOL = 1_000_000_000n;
export const SOLANA_LAMPORTS_PER_SIGNATURE = 5_000n;

export const formatLamportsAsSol = (lamports: bigint): string => {
  const sign = lamports < 0n ? "-" : "";
  const absolute = lamports < 0n ? -lamports : lamports;
  const whole = absolute / LAMPORTS_PER_SOL;
  const fractional = absolute % LAMPORTS_PER_SOL;
  if (fractional === 0n) return `${sign}${whole.toString()}`;
  const fractionalText = fractional
    .toString()
    .padStart(9, "0")
    .replace(/0+$/, "");
  return `${sign}${whole.toString()}.${fractionalText}`;
};
